<template>  
    <div class="cart-page-print" id="print-area">
        
        <div ref="header" :class="{
            'sticky-wrapper': arrivedAtTop || !!animation || !breakpoints.smaller('laptop'),
            ...(animation ? {[animation]: true} : null)
            }
        ">
            <div class="cart-page__title-wrapper">
                <div>
                    <a class="title-s cart-print__backCta" :href="route('cart.show')">Back to Cart</a>
                    <h1 class="headline-xl">Your Cart</h1>
                </div>
                <div class="cart-page__cart-actions">
                    <RothcoCta @click="toggleImages" class="secondary small" aria-label="View Cart">{{ isShowImages ? 'Hide' : 'Show' }} Product Images</RothcoCta>
                    <RothcoCta @click="printCart" class="secondary small" aria-label="Print Cart">Print</RothcoCta>
                </div>
            </div>
        </div>
        <table class="cart-print-table">
            <thead>
                <tr>
                    <th class="text-center" v-if="isShowImages">Image</th>
                    <th class="text-left">Item</th>
                    <th>Item#</th>
                    <th v-if="canSeePricing">Price</th>
                    <th>Qty</th>
                    <th v-if="canSeePricing">Subtotal</th>
                </tr>
            </thead>
            <ListItemPrint
                v-for="(listItem, index) in list_items"
                :key="index"
                :list_item="listItem"
                :show_image="isShowImages"
            />
        </table>
    </div>
</template>
<script lang="ts" setup>
    import { ref, toRefs, computed, watch } from "vue";
    import ListItemPrint from "@/components/cart/ListItemPrint.vue";
    import RothcoCta from "@/components/RothcoCta.vue";
    import { useScroll, useElementVisibility } from "@vueuse/core";
    import { useRothcoBreakpoints } from "@/helpers/composables/useBreakpoints";
    import { useSettingsStore  } from "@/store/settings";
    import { storeToRefs } from "pinia";


    let { list, list_items } = defineProps({
        list: {
            type: Object as PropType<List>,
            default: {}
        },
        list_items: {
            type: Array<any>,
            default: {}
        }
    });

    let breakpoints = {
        current: () => [],
        smaller: (str) => false,
        larger: (str) => false
    };
    const arrivedAtTop = ref(false);
    const animation = ref(null);

    let wasScrollingUp = ref(false);
    let wasScrollingDown = ref(false);
    let timeoutRef = ref();
    let scrollUpTimeoutRef = ref();
    let headerBottom = ref(null); //template ref


    let settings = useSettingsStore();
    const { canSeePricing } = storeToRefs(settings);
    let isShowImages = ref(true);

    const toggleImages = function () {
        isShowImages.value = !isShowImages.value;
    };

    let printCart = function ($event: Event) {
        window.print();
    };


    let { directions, arrivedState, y:yPos } = useScroll(window);

    let headerIsVisible = useElementVisibility(headerBottom);

    let { top: isScrollingUp, bottom: isScrollingDown  } = toRefs(directions);

    breakpoints = useRothcoBreakpoints();

    const arrivedAtTopComputed = computed(()=>{
        // checking y scrolling position necessary for safari browsers
        return arrivedState?.top || yPos?.value < 0;
    })
    
    watch(arrivedAtTopComputed, (newVal)=>{
        arrivedAtTop.value = newVal;
        if(newVal){
            animation.value = null;
        }
    }, {immediate: true})

    const startedScrollingUpFrom = ref(null);
    const pixelsScrolledUp = computed(()=>{
        if(startedScrollingUpFrom.value !== null){
            return startedScrollingUpFrom.value - yPos.value;
        }else{
            return 0;
        }
    });

    watch(()=>(yPos.value),(newYPos,oldYPos)=>{
        if(newYPos < oldYPos && !arrivedAtTopComputed.value && animation.value !== 'sticky-animate-show'){
            if(startedScrollingUpFrom.value === null) startedScrollingUpFrom.value = newYPos;
        }else{
            startedScrollingUpFrom.value = null;
        }
    })

    watch([isScrollingUp, isScrollingDown, pixelsScrolledUp], 
        ([newScrollUp, newScrollDown, newPixelsScrolledUp])=>{
            if(!breakpoints.current().value.includes('laptop')){
                animation.value = 'sticky-animate-show';
                return;
            };
            if(newScrollUp || newScrollDown){
                timeoutRef.value = setTimeout(()=>{
                    if(newScrollUp){
                        if(!wasScrollingUp.value) {
                            scrollUpTimeoutRef.value = setTimeout(()=>{
                                if(isScrollingUp.value || arrivedAtTop.value){
                                    wasScrollingUp.value = true;
                                    if(!headerIsVisible.value || animation.value === 'sticky-animate-hide'){
                                        animation.value = 'sticky-animate-show';
                                    }else{
                                        animation.value = null;
                                    }
                                }
                                
                            }, 4000);
                        }
                        if(newPixelsScrolledUp > 600){
                            clearTimeout(scrollUpTimeoutRef.value);
                            if(isScrollingUp.value || arrivedAtTop.value){
                                wasScrollingUp.value = true;
                                if(!headerIsVisible.value || animation.value === 'sticky-animate-hide'){
                                    animation.value = 'sticky-animate-show';
                                }else{
                                    animation.value = null;
                                }
                            }
                        }
                        if(wasScrollingDown.value) wasScrollingDown.value = false;

                    }else if(newScrollDown){
                        clearTimeout(scrollUpTimeoutRef.value);
                        if(!wasScrollingDown.value) wasScrollingDown.value = true;
                        if(wasScrollingUp.value) {
                            wasScrollingUp.value = false;
                        }

                        if(animation.value === 'sticky-animate-show'){
                            animation.value = 'sticky-animate-hide';
                        }
                    }
                }, 10);
            }
    })
</script>

<style scoped> 

</style>
